const editProfileInfoDictIT = {
  choose: "Scegliere",
  cancel: "Annulla",
  dragImgFile: "Trascina qui il file immagine",
  zipCode: "Codice Postale",
  country: "Paese",
  state: "Stato",
  city: "Città",
  publicPlace: "Indirizzo",
  district: "Quartiere",
  number: "Numero civico",
  countryPhoneCode: "Prefisso Tel. del Paese",
  regionalPhoneCode: "Prefisso Tel. Regionale",
  phoneNumber: "Numero di Tel.",
  changeProfilePic: "Cambia Immagine del Profilo",
  confirmProfileChanges: "Conferma le Modifiche al Profilo",
  // toast
  pleaseChoosePfp: "Scegli prima un'immagine del profilo.",
  fileSizeTooBig: "La dimensione del file è troppo grande.",
  unexpectedErrorUploadImg: "Errore imprevisto durante il caricamento dell'immagine.",
  usernameCantBeEmpty:
    "Il nome utente deve contenere solo lettere minuscole e numeri. Non può essere vuoto o contenere spazi.",
  usernameNotAvailable: "Nome utente non disponibile.",
  unexpectedErrorChangingPfp: "Errore imprevisto durante la modifica del profilo.",
  sucessfullyEditedProfile: "Profilo modificato con successo.",
  unexpectedSystemBehaviour: "Comportamento imprevisto del sistema.",
  canRetriveOnSaturdays: "Il servizio di spedizione può ritirare l'ordine di sabato?",
  quantityOfDaysToRetrive:
    "Quantità di giorni per il servizio di spedizione per ritirare il tuo ordine e portarlo a destinazione",
  settingsPageTitle: "Impostazioni",
  settingsPageProfileInfoTitle: "Informazioni profilo",
  settingsPageSubtitle: "Gestisci le tue preferenze e opzioni.",
  upgradeAccount: "Upgrade account",
  logout: "Esci",
  settingsTabGeneral: "Impostazioni generali",
  settingsTabProfile: "Impostazioni profilo",
  profileSettingsSubtitle: "Aggiorna il tuo profilo e le preferenze di spedizione.",
  settingsTabPrivacy: "Privacy e sicurezza",
  settingsMenuSelection: "Menu di selezione",
  regionalPreferences: "Preferenze regionali",
  regionalPreferencesSubtitle: "Seleziona le preferenze per la tua regione.",
  language: "Lingua",
  timezone: "Fuso orario",
  timeFormatOptional: "Formato ora (Opzionale)",
  dateFormatOptional: "Formato data (Opzionale)",
  hours: "ore",
  contactInfo: "Informazioni di contatto",
  contactInfoSubtitle: "Inserisci telefono e indirizzo.",
  applyChanges: "Applica modifiche",
  confirm: "Conferma",
  changePassword: "Cambia password",
  changePasswordSubtitle: "Aggiorna la password per una maggiore sicurezza.",
  currentPassword: "Password attuale",
  newPassword: "Nuova password",
  confirmPassword: "Conferma nuova password",
  passwordMustContainAtLeast: "Deve contenere almeno:",
  passwordRequirementUppercase: "1 lettera maiuscola",
  passwordRequirementNumber: "1 numero",
  passwordRequirementLength: "8 caratteri",
  passwordStrengthNone: "",
  passwordStrengthWeak: "Debole",
  passwordStrengthMedium: "Media",
  passwordStrengthStrong: "Forte",
  loading: "Caricamento...",
  deleteAccount: "Elimina account",
  deleteAccountSubtitle: "Gestisci la cancellazione dell'account.",
  deleteAccountWarning: "Questa azione non può essere annullata.",
  deleteAccountInfo: "Tutti i tuoi dati saranno rimossi permanentemente.",
  writeCancelToConfirm: "Scrivi CANCELLARE per confermare",
  confirmYourPassword: "Conferma la tua password",
  passwordChangedSuccessfully: "Password modificata con successo.",
  accountCanceledSuccessfully: "Account cancellato con successo.",
  passwordFieldsMismatched: "Le password non coincidono.",
  cancelAccountError: "Errore durante la cancellazione dell'account.",
  firstName: "Nome",
  surname: "Cognome",
  username: "Nome utente",
  uploadImage: "Carica immagine",
  freight: "Spedizione",
  select: "Seleziona",
  profileAnalysisTab: "Analisi del Profilo",
  profileAnalysisMenuItem: "Analisi del Profilo",
  profileAnalysisTitle: "Analisi del Profilo e degli Obiettivi",
  profileAnalysisSubtitle:
    "Rispondi a queste brevi domande per aiutarci a capire i tuoi obiettivi.",
  profileAnalysisAddress: "Indirizzo",
  profileAnalysisAddressHelp: "Inserisci il tuo indirizzo di residenza attuale.",
  profileAnalysisNationality: "Nazionalità",
  profileAnalysisBirthPlace: "Luogo di Nascita",
  profileAnalysisBirthDate: "Data di Nascita",
  profileAnalysisBirthDatePlaceholder: "GG/MM/AAAA",
  profileAnalysisPhone: "Telefono",
  profileAnalysisEmail: "E-mail",
  profileAnalysisEmployment: "Attività Lavorativa",
  profileAnalysisMaritalStatus: "Stato Civile",
  profileAnalysisEducationLevel: "Titolo di Studio",
  profileAnalysisHouseholdMembers: "Componenti Nucleo Familiare",
  profileAnalysisObjectives: "Obiettivi",
  profileAnalysisNeeds: "Esigenze",
  profileAnalysisDateLabel: "Data: ",
  profileAnalysisConsultantLabel: "Consulente: ",
  profileAnalysisNoData: "—",
  profileAnalysisConsentLabel: "Acconsento",
  profileAnalysisConsentText:
    "Le informazioni verranno utilizzate per elaborare una valutazione gratuita per la piattaforma EXTRACONOMY.",
  profileAnalysisSendDiagnosis: "Invia Diagnosi",
  profileAnalysisUpdateDiagnosis: "Aggiorna Diagnosi",
  profileAnalysisSubmitSuccess: "Diagnosi inviata con successo.",
  profileAnalysisMaritalSingle: "Celibe/Nubile",
  profileAnalysisMaritalMarried: "Coniugato/a",
  profileAnalysisMaritalDivorced: "Divorziato/a",
  profileAnalysisMaritalWidowed: "Vedovo/a",
  profileAnalysisMaritalCivilUnion: "Unione civile",
  profileAnalysisMaritalSeparated: "Separato/a",
};

export default editProfileInfoDictIT;
